import request from 'message-control/utils/request'
import api from 'message-control/common/api/setting'

export async function info() {
    return request(api.info.url)
}

export async function update(payload) {
    return request(api.update.url, {
        method: api.update.type,
        body: payload.body,
    })
}

export async function publicKey() {
    return request(api.publicKey.url)
}

export async function regeneratePublicKey() {
    return request(api.regeneratePublicKey.url, {
        method: api.regeneratePublicKey.type,
    })
}

export async function publicKeyVersion() {
    return request(api.publicKeyVersion.url)
}

export async function updatePublicKeyVersion(params = {}) {
    return request(api.updatePublicKeyVersion.url, {
        method: api.updatePublicKeyVersion.type,
        body: params.body,
    })
}

// 获取扩展资料中-自动绑定订单手机号-状态
export async function getBindPhoneStatus() {
    return request(api.getBindPhoneStatus.url)
}

// 变更扩展资料中-自动绑定订单手机号-状态
export async function setBindPhoneStatus(payload) {
    return request(api.setBindPhoneStatus.url, {
        method: api.setBindPhoneStatus.type,
        body: payload.body,
    })
}
